import React, { Component } from 'react';

import './index.css';
// import unSelect from './path-bar.svg'
// import onSelect from './path-bar.svg'
import pathWhite from './path-bar-white.svg'
import pathBlue from './path-bar-blue.svg'
// import unSelect from './drag_line.svg';
// import onSelect from './drag_line_hover.svg';

class SwipeScan extends Component {
  constructor(props) {
    super(props);
    // 初始化state
    this.state = {
      // 滑动条初始左偏移
      initX: 0,
      // 滑动条动态左偏移 即默认显示位置
      needX: -28,
      // 滑动条的宽度
      SliderW: 0,
      // 扫描盒子宽度和高度
      boxW: 0,
      boxH: 0,
      // 滑动条选中状态
      isSelect: false,
    };
  }

  componentDidMount = () => {
    // 封装设置元素高宽的函数
    this.setWidHei();
    // 监听 当窗口大小发生变化触发
    window.addEventListener('resize', this.onResize);
  };

  // 销毁监听
  componentWillUnmount = () => {
    document.body.removeEventListener('mousemove', this.onMouseMove);
    document.body.removeEventListener('mouseup', this.onMouseUp);
    window.removeEventListener('resize', this.onResize);
  };

  // 封装设置元素高宽的函数
  setWidHei = () => {
    // 获取扫描盒子的宽度 即右边图片的大小宽度
    const cWidth = document.getElementsByClassName('scanBox')[0].clientWidth
    const cHeight = document.getElementsByClassName('scanBox')[0].clientHeight
    const sliderWidth = document.getElementsByClassName('slider')[0].clientWidth
    this.setState({
      boxW: cWidth,
      boxH: cHeight,
      SliderW: sliderWidth,
    });
    // 初始化位置在中间
    const resultX = (cWidth - sliderWidth)/2;
    this.setState({
      needX: resultX,
    });
  };

  // 当窗口大小发生变化触发
  onResize = () => {
    this.setWidHei();
    // eslint-disable-next-line no-restricted-globals
    location.reload();
  };

  // 移动端触碰事件
  onTouchDown = (e) => {
    // console.log("onMouseDown", e)
    let { initX } = this.state;
    // 当前屏幕点下的页面位置-当前元素的左偏移=滑动条初始左偏移
    initX = e.changedTouches[0].clientX - e.target.offsetLeft;
    this.setState({ initX, isSelect: true });
    // 给body绑定屏幕移动监听事件
    document.body.addEventListener('touchmove', this.onTouchMove);
    // 给body绑定屏幕弹起监听事件
    document.body.addEventListener('touchend', this.onTouchUp);
  }

  // 当鼠标移动触发事件
  onTouchMove = (e) => {
    const { boxW, SliderW } = this.state;
    // 动态滑动距离
    let resultX = 0;
    // 鼠标移动距离
    const MoveX = e.changedTouches[0].clientX - this.state.initX;
    if (MoveX <= -28) {
      resultX = -28;
    } else if (MoveX >= boxW - SliderW + 27) {
      resultX = boxW - SliderW + 27;
    } else {
      resultX = MoveX;
    }
    this.setState({
      needX: resultX,
    });
  };

  // 当鼠标弹起触发事件
  onTouchUp = () => {
    this.setState({ isSelect: false });
    document.body.removeEventListener('touchmove', this.onTouchMove);
    document.body.removeEventListener('touchend', this.onTouchUp);
  };



  // 当鼠标点下触发事件
  onMouseDown = (e) => {
    // console.log("onMouseDown", e)
    let { initX } = this.state;
    // 当前鼠标点下的页面位置-当前元素的左偏移=滑动条初始左偏移
    initX = e.clientX - e.target.offsetLeft;
    this.setState({ initX, isSelect: true });
    // 给body绑定鼠标移动监听事件
    document.body.addEventListener('mousemove', this.onMouseMove);
    // 给body绑定鼠标弹起监听事件
    document.body.addEventListener('mouseup', this.onMouseUp);
  };

  // 当鼠标移动触发事件
  onMouseMove = (e) => {
    const { boxW, SliderW } = this.state;
    // 动态滑动距离
    let resultX = 0;
    // 鼠标移动距离
    const MoveX = e.clientX - this.state.initX;
    if (MoveX <= -28) {
      resultX = -28;
    } else if (MoveX >= boxW - SliderW + 27) {
      resultX = boxW - SliderW + 27;
    } else {
      resultX = MoveX;
    }
    this.setState({
      needX: resultX,
    });
  };

  // 当鼠标弹起触发事件
  onMouseUp = () => {
    this.setState({ isSelect: false });
    document.body.removeEventListener('mousemove', this.onMouseMove);
    document.body.removeEventListener('mouseup', this.onMouseUp);
  };

  render() {
    const { needX, isSelect, boxW, boxH } = this.state;
    const { leftImg, rightImg, mobile, modalType } = this.props;
    const nodropStyle = mobile ? 'mobileNoDrag' : 'noDrag'
    // 滑动条的左边偏移量
    const sliderStyle = {
      left: needX,
      // 如果滑动条是选中状态则选择第一个背景图片，否则第二个
      backgroundImage: 'logo-trans'===modalType ? `url(${pathBlue})` : `url(${pathWhite})`,
      // width: '13%',
      // paddingBottom: '15%'
      // paddingLeft: '20.85%', /* 316 / 1024 */
      backgroundSize: '56px 100%' 
      // width: '15%'
    };
    // 修改左边盒子的宽度和高度，避免页面大小变化时出现不对齐的情况
    const rightBoxStyle = {
      width: needX + 28,
      height: boxH,
    };
    // 固定左边图片的高宽，避免页面大小变化时出现不对齐的情况
    const rightImgStyle = {
      width: boxW,
      height: boxH,
    };
    return (
      <div className='scanBox noSelect' onMouseUp={this.onMouseUp}>
        {/* 左边盒子 */}
        <div className='left noSelect' style={rightBoxStyle}>
          {/* 左边图片 */}
          <img
            alt='after'
            src={leftImg}
            className={nodropStyle}
            style={rightImgStyle}
          />
        </div>
        {/* 滑动条 */}
        <div
          onMouseDown={this.onMouseDown}
          onTouchStart={this.onTouchDown}
          className='slider'
          style={sliderStyle}
          z-index='1000'
        ></div>
        {/* 右边盒子 */}
        <div className='right noSelect'>
          {/* 右边盒子 */}
          <img alt='before' src={rightImg} onLoad={this.setWidHei} className={'rightPic '+ nodropStyle}/>
        </div>
      </div>
    );
  }
}

export default SwipeScan;